import { DeviceState, DeviceStatusUpdate } from '../device-status';
import { GateError } from '../gate-error';
import { GateState } from '../gate-state';
import { PermissionEvent } from '../permission';

export interface WsEventMessage {
    EventId: number;
    Description: string;
    Data: string; // DeviceState stringyfied
    Category: string;
    UserId: number;
    DeviceId: number;
    EventDate: Date;
    CreatedAt: Date;
    Message: string;
    NotifyLevel: number;
    StateEventDescr: string;
    DeviceState?: DeviceState;
    PermissionEvent: PermissionEvent;
}

export const partialUpdateFromEvent = (event: WsEventMessage, gateStates: GateState[], gateErrors: GateError[]): DeviceStatusUpdate => {
    const changes: DeviceStatusUpdate = {};
    switch (event.DeviceState.DeviceEventId) {
        case 12:
        case 14:
        case 16:
            changes.Configured = 0;
            break;
        case 13:
        case 15:
        case 17:
            changes.Configured = 1;
            break;
        case 21: // automation status update
            const command = gateStates.find(s => s.Id === event.DeviceState.Payload[0]);
            if (command) {
                changes.CommandDescription = command.Description;
                changes.CommandName = command.Name;
            }
            changes.Percentage = event.DeviceState.Payload[1];
            changes.LastSeen = new Date();
            break;
        case 22: // "device error status" update ( "0" => everything ok )
            const errCode = event.DeviceState.Payload[0];
            if (errCode === 0) {
                changes.LastSeen = new Date();
                changes.Errored = false;
                changes.ErrorDescription = '';
                break;
            }
            changes.Errored = true;
            const errorDetails = gateErrors.find(ec => ec.Id === errCode);
            if (errorDetails) {
                changes.ErrorDescription = errorDetails.Description;
            }
            break;
        case 23: // maneuvers count update
            const u8 = new Uint8Array(event.DeviceState.Payload.slice(0, 8));
            changes.Openings = new DataView(u8.buffer).getInt32(0);
            changes.Closures = new DataView(u8.buffer).getInt32(4);
            changes.LastSeen = new Date();
            break;
        case 24: // GW subGW inputs update
            changes.InputsStatus = event.DeviceState.Payload;
            changes.LastSeen = new Date();
            break;
        case 25: // GW subGW outputs update
            changes.OutputsStatus = event.DeviceState.Payload;
            changes.LastSeen = new Date();
            break;
        case 26: // online/offline update
            changes.Online = event.DeviceState.Payload[0] === 1;
            changes.LastSeen = new Date();
            break;
        case 27: // Input label update
            changes.Inputs = new Map();
            changes.Inputs.set(event.DeviceState.InputId, event.DeviceState.StateLabel);
            changes.LastSeen = new Date();
            break;
        case 28: // Output label update
            changes.Outputs = new Map();
            changes.Outputs.set(event.DeviceState.OutputId, event.DeviceState.StateLabel);
            changes.LastSeen = new Date();
            break;
        case 40: // RBE 24 AUTOMATIONS STATUS ONLINE OFFLINE
            if (event.DeviceState.Payload[0] === 0) { // Status offline
                changes.AutomationsStatus = [255];// Status offline
                changes.CrpId = event.DeviceState.CrpId;
                changes.LastSeen = new Date();
            }
            break;
        case 41: // RBE 24 AUTOMATIONS STATUS UPDATE TO CHECK
            changes.AutomationsStatus = event.DeviceState.Payload;
            changes.CrpId = event.DeviceState.CrpId;
            changes.LastSeen = new Date();
            break;
        case 46:
            changes.ScanConnectedAutomation = false;
            break;
        case 47:
            changes.ScanConnectedAutomation = true;
            break;
    };
    return changes;
};

/*
{
    Data: "{"DeviceEventId":26,"DeviceId":13,"Payload":[0]}"
    DeviceId: 13
    Message: "Il dispositivo banco andrea e' Offline"
    NotifyLevel: 0
    StateEventDescr: "DeviceOnline"
    Success: true
}

*/
